import { api } from '../utils';

export class Logger {
  constructor(hotelId) {
    this.hotelId = hotelId;
    this.info = [];
    this.timeout = null;
    this.hotelId = null;
    this.sended = false;
    this.processLine = null;
  }
  addLine = (message, info) => {
    const newInfo = info && info instanceof Error ? info.toString() : JSON.stringify(info);
    this.info.push({ url: window.document.location.href, message, error: newInfo });
    return this;
  };

  sendOnTimeout = (time = 300000) => {
    this.timeout = setTimeout(() => {
      this.sendMail();
    }, time);
    return this;
  };

  clearLog = () => {
    this.info = [];
    return this;
  };
  process = key => {
    this.processLine = key || null;
    return this;
  };

  cancelSend = () => {
    this.timeout && clearTimeout(this.timeout);
    return this;
  };

  sendIfErrors = (message, info) => {
    if (this.sended) {
      this.addLine(message, info).sendMail();
    }
    return this;
  };

  sendMail = (message, info, force) => {
    if (window.enableAvailErrors && this.hotelId && (force || !this.processLine || this.processLine === 'run')) {
      if (message || info) {
        this.addLine(message, info);
      }
      if (this.info.length && process.env.NODE_ENV === 'production') {
        api.post('cms/send_avail_error', this.info, this.hotelId);
      }
      if (!force) {
        this.sended = true;
      }
      this.clearLog();
      this.cancelSend();
    }
    return this;
  };
}

let loggerObj;
export default hotelId => {
  return loggerObj ? loggerObj : (loggerObj = new Logger(hotelId));
};
